import {
  createSlice,
  type PayloadAction,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import type { BrandingSliceState } from './branding.type';
import { api } from '../../services/branding/operations.generated';
import { type CustomBranding } from '../../services/graphQlTypes.generated';

const initialState: BrandingSliceState = {
  isPending: true,
  branding: undefined,
};

export const brandingSlice = createSlice({
  name: 'branding',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(initializeAsync.pending, (state) => {
      state.isPending = true;
    });

    builder.addCase(
      initializeAsync.fulfilled,
      (state, action: PayloadAction<CustomBranding | null>) => {
        if (action.payload !== null) {
          state.branding = action.payload;
        }

        state.isPending = false;
      },
    );

    builder.addMatcher(
      api.endpoints.getCustomBranding.matchFulfilled,
      (state, { payload }) => {
        const result = payload.Tenant?.customBranding as
          | CustomBranding
          | undefined;
        if (result) {
          state.branding = {
            ...result,
            primaryColor: result.primaryColor ?? undefined,
          };
        }
      },
    );
  },
});

export const initializeAsync = createAsyncThunk(
  'branding/initialize',
  async (
    tenantId: string | undefined,
    { dispatch },
  ): Promise<CustomBranding | null> => {
    if (!tenantId) {
      return null;
    }

    const brandingResult = await dispatch(
      api.endpoints.getCustomBranding.initiate(undefined),
    ).unwrap();

    const result = brandingResult.Tenant?.customBranding as
      | CustomBranding
      | undefined;
    if (!result) {
      return null;
    }
    return {
      ...result,
      primaryColor: result.primaryColor ?? undefined,
    };
  },
);
